<form [formGroup]="menuService.form" (ngSubmit)="saveAndContinue()" class="px-0 px-sm-3"
    [ngClass]="{ 'py-5 position-relative': isDialog }">
    <div class="container-fluid px-0 px-sm-3">
        <i matTooltip="Cerrar" class="fas fa-times fa-2xl close-icon-actions" *ngIf="isDialog"
            (click)="dialogRef.close()"></i>
        <h4 *ngIf="isDialog" class="text-bold text-center px-3">
            Destino del servicio
        </h4>
        <div *ngIf="canSeeDestinationDownloadService">
            <div class="geo-map-wrapper mb-3" *ngIf="hasAnyDestinationCity()">
                <div class="geo-map-header">
                    <span class="geo-map-title">
                        <i class="fas fa-map-marked-alt mr-2"></i>Mapa de destinos
                    </span>
                    <button type="button" class="geo-map-toggle" (click)="toggleDestinationMap()">
                        <i class="fas" [ngClass]="showDestinationMap ? 'fa-eye-slash' : 'fa-eye'"></i>
                        <span>{{ showDestinationMap ? 'Ocultar mapa' : 'Mostrar mapa' }}</span>
                    </button>
                </div>
                <div class="geo-map-body" *ngIf="showDestinationMap">
                    <app-standard-map (mapReady)="onMapReady()"></app-standard-map>
                </div>
            </div>
            <div class="d-flex flex-wrap mt-4" *ngFor="let destination of destinationsControls.controls; let i=index">
                <div class="col-12 px-0 d-flex justify-content-between align-items-center">
                    <p class="mb-2 text-bold">Destino {{i + 1}}</p>
                    <i class="fas fa-times cursor-pointer" matTooltip="Eliminar destino"
                        *ngIf="i && canEditDestinationDownloadService && destination.get('destinationCity').enabled && (!isDialog || !menuService?.cargo?.ministry)"
                        (click)="removeDestinationForm(i)"></i>
                </div>
                <app-autocomplete-city [inputFormControl]="destination.get('destinationCity')"
                    [options]="destinationCityOptions[i]"
                    [validate]="destination.get('destinationCity').disabled ? 'disable' : formValidate"
                    [ngClass]="{'col-md-6': !isInternationalTrip, 'col-md-12': isInternationalTrip}">
                </app-autocomplete-city>
                <div class="col-md-6 pb-3 pb-md-0" *ngIf="isInternationalTrip">
                    <label class="text-strong">¿Es Internacional?&nbsp;&nbsp;</label>
                    <mat-button-toggle-group [formControl]="destination.get('isInternational')"
                        #group="matButtonToggleGroup">
                        <mat-button-toggle [value]="true" (change)="onChangeInternational(i)">
                            Si
                        </mat-button-toggle>
                        <mat-button-toggle [value]="false" (change)="onChangeInternational(i)">
                            No
                        </mat-button-toggle>
                    </mat-button-toggle-group>
                </div>
                <mat-form-field appearance="outline" class="col-md-6">
                    <mat-label>
                        Fecha estimada {{menuService?.isTransportService() ? 'de descargue':'de llegada' }}
                        <span class="asterisk">*</span>
                    </mat-label>
                    <input matInput
                        [min]="i ? destinationsControls?.controls[i - 1]?.get('destinationDate')?.value : originDate"
                        [matDatepicker]="pickerLoadDate" [formControl]="destination.get('destinationDate')"
                        name="destinationDate" (click)="pickerLoadDate.open()" readonly
                        [max]="menuService?.isTransportService() ? maxDate: null">
                    <mat-datepicker-toggle matSuffix [for]="pickerLoadDate"></mat-datepicker-toggle>
                    <mat-datepicker #pickerLoadDate></mat-datepicker>
                    <mat-error *ngIf="destination.get('destinationDate').errors?.required">
                        {{ utils.giveMessageError('MANDATORY_FIELD') }}
                    </mat-error>
                </mat-form-field>
                <mat-expansion-panel *ngFor="let address of getDestinationAddresses(i).controls; let j=index"
                    [expanded]="indexOpened.indexDestination === i && indexOpened.indexAddress === j"
                    [togglePosition]="'before'" class="col-12">
                    <mat-expansion-panel-header (click)="setIndexOpened(i, j)" class="cursor-pointer">
                        <mat-panel-title class="text-strong position-relative">
                            Direccion {{j + 1}}
                            <i class="fas fa-times-circle icon-delete" matTooltip="Eliminar dirección"
                                *ngIf="j && canEditDestinationDownloadService && address.get('address').enabled && (!isDialog || !menuService?.cargo?.ministry)"
                                (click)="removeDestinationAddressForm(i, j)"></i>
                        </mat-panel-title>
                    </mat-expansion-panel-header>
                    <div class="col-12 d-flex flex-wrap px-0"
                        *ngIf="indexOpened.indexDestination === i && indexOpened.indexAddress === j">
                        <mat-form-field appearance="outline" class="col-md-6">
                            <mat-label>Hora estimada <span class="asterisk">*</span></mat-label>
                            <input matInput [formControl]="address.get('time')" type="time">
                            <mat-error *ngIf="address.get('time').errors?.required">
                                {{ utils.giveMessageError('MANDATORY_FIELD') }}
                            </mat-error>
                        </mat-form-field>
                        <mat-form-field appearance="outline" class="col-md-6" *ngIf="menuService.isTransportService()">
                            <mat-label>
                                Celular de contacto
                                <span class="optional">(opcional)</span>
                            </mat-label>
                            <input matInput onlyNumbersInt type="tel" [formControl]="address.get('cellphone')">
                            <mat-error *ngIf="address.get('cellphone').errors?.minlength">
                                {{ utils.giveMessageError('MIN_LENGTH_NOT_REACHED', 'celular', 10) }}
                            </mat-error>
                        </mat-form-field>
                        <mat-form-field appearance="outline" class="col-12" *ngIf="menuService.isTransportService()">
                            <mat-label>
                                Correo de contacto
                                <span class="optional">(opcional)</span>
                            </mat-label>
                            <input matInput type="email" [formControl]="address.get('email')">
                            <mat-error *ngIf="address.get('email').errors?.email">
                                {{ utils.giveMessageError('INVALID_EMAIL') }}
                            </mat-error>
                        </mat-form-field>
                        <mat-checkbox [formControl]="address.get('hasThirdParty')"
                            class="col-md-6 pb-3 text-bold align-self-end"
                            *ngIf="menuService.isTransportService() && menuService.isMinistryService() && !destination.get('isInternational').value">
                            <span class="text-wrap-balance">Esta dirección va incluida en la remesa</span>
                        </mat-checkbox>
                        <app-autocomplete-address
                            *ngIf="menuService.isTransportService() && !address.get('hasThirdParty').value"
                            class="col-md-12 mb-3" [options]="{
                            title: destinationAddressOptions.title,
                            appearance: destinationAddressOptions.appearance,
                            initialValue: address.get('address')?.value?.address,
                            internationalCode: destination.get('destinationCity')?.value?.code,
                            municipalityCode: destination.get('destinationCity')?.value?.id,
                            showHintRequiredAddressSelection: true,
                            selectAddressOnMap: true,
                            correctAddress: true
                        }" [inputFormControl]="address.get('address')"
                            [validate]="address.get('address').disabled ? 'disable' : formValidate">
                        </app-autocomplete-address>
                        <app-geo-validation-feedback class="col-12"
                            *ngIf="menuService.isTransportService() && !address.get('hasThirdParty').value && !destination.get('isInternational').value"
                            [validating]="address.get('address').pending"
                            [error]="address.get('address').errors?.outsideMunicipality">
                        </app-geo-validation-feedback>
                        <!-- Third party -->
                        <ng-container *ngIf="!menuService.isTransportService() || address.get('hasThirdParty').value">
                            <app-autocomplete-thirdparty class="col-md-6" [options]="{
                                    title: 'Destinatario',
                                    appearance: 'outline',
                                    initialValue: address.get('thirdParty')?.value?.document ? address.get('thirdParty')?.value?.document : initialAddresses[i] ? initialAddresses[i][j]?.initialThirdParty: null
                                }" [inputFormControl]="address.get('thirdParty')"
                                [validate]="address.get('address').disabled ? 'disable' : formValidate">
                            </app-autocomplete-thirdparty>
                            <app-autocomplete-thirdparty-address [inputFormControl]="address.get('thirdPartyAddress')"
                                class="col-12" [validate]="address.get('address').disabled ? 'disable' : formValidate"
                                [options]="{
                                    title: 'Dirección de destinatario',
                                    appearance: 'outline',
                                    companyId: address.get('thirdParty').value?.document,
                                    municipalityCode: destination.get('destinationCity')?.value?.id,
                                    thirdParty: address.get('thirdParty').value,
                                    initialValue: address.get('thirdPartyAddress')?.value?.branchOfficeName
                                        ? address.get('thirdPartyAddress')?.value?.branchOfficeName
                                        : address.get('thirdPartyAddress')?.value?.address?.address
                                        ? address.get('thirdPartyAddress')?.value?.address?.address
                                        : initialAddresses[i] ? initialAddresses[i][j]?.initialValue: null
                                    , showEditAddress: !isDialog
                                }" (emitToParent)="saveAndContinue()">
                            </app-autocomplete-thirdparty-address>
                            <app-geo-validation-feedback class="col-12"
                                *ngIf="!destination.get('isInternational').value"
                                [validating]="address.get('thirdPartyAddress').pending"
                                [error]="address.get('thirdPartyAddress').errors?.outsideMunicipality">
                            </app-geo-validation-feedback>
                            <div *ngIf="address?.get('thirdPartyAddress')?.value && address?.get('thirdPartyAddress')?.value?.information?.document !== address?.get('thirdParty')?.value?.document"
                                class="alert alert-warning col-12" role="alert">
                                La dirección de destinatario no coincide con el destinatario
                            </div>
                        </ng-container>


                        <div class="col-12 row pl-3"
                            *ngIf="menuService.isTransportService() && canEditGuidesRecipients && !isDialog">
                            <p class="col-md-12 text-bold"
                                *ngIf="canEditDestinationDownloadService || getDestinationAddressGuidesRecipients(i, j)?.controls?.length > 0">
                                Informacion de guías
                            </p>
                            <div class="col-md-12 row mb-2 pr-0 mb-1"
                                *ngFor="let guide of getDestinationAddressGuidesRecipients(i, j).controls; let indexGuide = index;">
                                <div class="col-md-12 d-flex justify-content-between text-bold">
                                    <span>Guía N°{{indexGuide + 1}}</span>
                                    <i class="fas fa-trash-alt font-primary-light cursor-pointer"
                                        [matTooltip]="'Eliminar guía'"
                                        (click)="removeGuideRecipientForm(i, j, indexGuide)"></i>
                                </div>
                                <mat-form-field appearance="outline" class="col-sm-6">
                                    <mat-label>Nombre<span class="optional">(Opcional)</span></mat-label>
                                    <input matInput type="text" [formControl]="guide.get('name')">
                                </mat-form-field>
                                <mat-form-field appearance="outline" class="col-sm-6">
                                    <mat-label>Celular<span class="optional">(Opcional)</span></mat-label>
                                    <input matInput type="text" [formControl]="guide.get('phone')" onlyNumbersInt>
                                </mat-form-field>
                                <mat-form-field appearance="outline" class="col-sm-6">
                                    <mat-label>Correo<span class="optional">(Opcional)</span></mat-label>
                                    <input matInput type="email" [formControl]="guide.get('email')">
                                </mat-form-field>
                                <mat-form-field appearance="outline" class="col-sm-6">
                                    <mat-label>N° de Guía<span class="optional">(Opcional)</span></mat-label>
                                    <i class="fas fa-info-circle fa-lg cursor-pointer color-secondary-dark" matSuffix
                                        matTooltip="Solo letras, números, guion (-) y guion bajo (_). Sin espacios ni caracteres especiales. 3 a 30 caracteres."
                                        matTooltipClass="tooltip__alert" matTooltipPosition="right"></i>
                                    <input matInput type="text" [formControl]="guide.get('clientId')">
                                    <mat-error
                                        *ngIf="guide.get('clientId').value && guide.get('clientId').errors?.minlength">
                                        {{ utils.giveMessageError('MIN_LENGTH_NOT_REACHED', 'N°. de guía', 3) }}
                                    </mat-error>
                                    <mat-error
                                        *ngIf="guide.get('clientId').value && guide.get('clientId').errors?.maxlength">
                                        {{ utils.giveMessageError('MAX_LENGTH_EXCEED', 'N°. de guía', 30) }}
                                    </mat-error>
                                    <mat-error
                                        *ngIf="guide.get('clientId').value && guide.get('clientId').errors?.pattern">
                                        {{ utils.giveMessageError('INVALID_FORMAT', 'N°. de guía') }}
                                    </mat-error>
                                </mat-form-field>
                            </div>
                            <p class="text-bold font-secondary-dark pl-2 cursor-pointer"
                                (click)="addGuideRecipientForm(i, j)" *ngIf="canEditDestinationDownloadService">
                                <i class="fas fa-plus-circle"></i>
                                <span>Agregar guía</span>
                            </p>
                        </div>
                    </div>
                </mat-expansion-panel>

                <p class="text-bold font-secondary-dark pl-4 mt-2 mb-5 cursor-pointer"
                    (click)="addDestinationAddressForm(i, true)"
                    *ngIf="canEditDestinationDownloadService && (!isDialog || !menuService?.cargo?.ministry) && canAddDestinationAddress(i)">
                    <i class="fas fa-plus-circle"></i>
                    <span>Agregar otra dirección</span>
                </p>
            </div>
            <p class="text-bold font-secondary-dark pl-2 cursor-pointer"
                *ngIf="canEditDestinationDownloadService && (!isDialog || !menuService?.cargo?.ministry)"
                (click)="addDestinationForm(true)">
                <i class="fas fa-plus-circle"></i>
                <span>Agregar otro destino</span>
            </p>
            <p class="col-12 alert alert-info text-bold text-center" role="alert"
                *ngIf="canEditDestinationDownloadService && isDialog">
                <i class="fas fa-info-circle"></i>
                <span>
                    Si realiza un cambio en alguna ciudad de destino, recuerde actualizar sus direcciones
                </span>
                <br *ngIf="menuService?.cargo?.ministry">
                <span *ngIf="menuService?.cargo?.ministry">
                    Si realiza un cambio en la fecha de descargue, recuerde actualizar las remesas asociadas a este
                    servicio
                </span>
            </p>
        </div>

        <div *ngIf="!canSeeDestinationDownloadService" class="no-permission-container">
            <i class="fas fa-exclamation-circle fa-lg m-2"></i>
            <h4 class="text-bold">No tienes permiso para acceder a esta información. Contacta a tu administrador para
                solicitar acceso.</h4>
        </div>

        <div class="button-container mt-4" *ngIf="!isDialog; else dialogButtons">
            <button mat-raised-button color="primary" class="button-width-auto primary-secondary button-small"
                [ngClass]="{'warn': true}" type="button" (click)="backToPreviousStep()">
                <span class="mat-button-wrapper">Atras</span>
            </button>
            <button type="submit" class="mx-2" mat-raised-button color="accent"
                *ngIf="canEditDestinationDownloadService">
                Guardar y Continuar
            </button>
            <button type="button" class="mx-2" mat-raised-button color="accent"
                *ngIf="!canEditDestinationDownloadService" (click)="continueToNextStep()">
                Continuar
            </button>
        </div>
        <ng-template #dialogButtons>
            <div class="button-container mt-4">
                <button class="mx-2" type="submit" mat-raised-button color="accent">
                    Guardar
                </button>
            </div>
        </ng-template>
    </div>
</form>